(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fb-click-discount"] && !Shopify.designMode) return;
  try {
    (() => {
  const popup = document.getElementById('fb-click-discount');
  if (!popup || !popup.showModal || window.Shopify?.designMode) return;
  const key = 'fb_coupon_click_v1';
  const get = () => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; } };
  const save = (days) => { try { localStorage.setItem(key, JSON.stringify({until:Date.now()+days*86400000})); } catch {} };
  let lastFocus;
  let timer;
  const stop = (days) => { clearTimeout(timer); save(days); if(popup.open) popup.close(); };
  popup.querySelector('.fb-coupon-close').addEventListener('click', () => stop(7));
  popup.addEventListener('cancel', () => stop(7));
  popup.addEventListener('close', () => lastFocus?.focus?.());
  popup.addEventListener('click', (event) => { if(event.target === popup){const r=popup.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)stop(7);} });
  document.addEventListener('click', (event) => { const link=event.target.closest('a[href]'); if(link && /\/discount\/Flora10(?:\?|$)/i.test(link.getAttribute('href'))) stop(30); });
  const blocked = () => get()?.until > Date.now();
  const desktop = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (desktop) {
    const show = () => {
      if(blocked() || document.hidden || document.querySelector('dialog[open]')) return;
      lastFocus=document.activeElement;
      popup.showModal();
      document.removeEventListener('mouseout', onOut);
    };
    const onOut = (event) => { if(!event.relatedTarget && event.clientY <= 0) show(); };
    timer=setTimeout(() => document.addEventListener('mouseout', onOut), 5000);
    return;
  }
  const bar = document.getElementById('fb-click-discount-bar');
  if (!bar || blocked()) return;
  bar.querySelector('.fb-coupon-bar-close').addEventListener('click', () => { save(7); bar.remove(); });
  const footerSel = 'footer, .footer, .shopify-section-group-footer-group';
  const anchor = () => [...document.querySelectorAll('#fb-conversion .fulfilment, #fb-conversion .trust, ' + footerSel)].find(el => el.getBoundingClientRect().top > window.innerHeight);
  let ready = false;
  const place = () => {
    if(!ready || bar.isConnected && !bar.hidden) return;
    const target = anchor();
    if(!target || blocked()) return;
    if(target.matches(footerSel)) target.before(bar); else target.after(bar);
    bar.hidden = false;
    window.removeEventListener('scroll', onScroll);
  };
  let tick;
  const onScroll = () => { clearTimeout(tick); tick=setTimeout(place, 200); };
  let start=Date.now();
  try { start=Number(sessionStorage.getItem('fb_coupon_start')) || start; sessionStorage.setItem('fb_coupon_start',String(start)); } catch {}
  timer=setTimeout(() => { ready=true; place(); window.addEventListener('scroll', onScroll, {passive:true}); }, Math.max(0,25000-(Date.now()-start)));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fb-customer-evidence"] && !Shopify.designMode) return;
  try {
    (() => {
  const shuffle = values => {
    const result = [...values];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };
  const rotate = () => {
    document.querySelectorAll('[data-fb-photo-rotation]').forEach(section => {
      const grid = section.querySelector('.fb-evidence__grid');
      if (!grid || grid.dataset.rotationReady) return;
      const cards = [...grid.querySelectorAll('.fb-evidence__card')];
      if (!cards.length) return;
      const storageKey = 'fb-plant-photos-v1:' + section.dataset.rotationKey;
      let previous = [];
      try { previous = JSON.parse(sessionStorage.getItem(storageKey) || '[]'); } catch {}
      if (!Array.isArray(previous)) previous = [];
      const previousKeys = new Set(previous);
      const fresh = shuffle(cards.filter(card => !previousKeys.has(card.dataset.photoKey)));
      const repeated = shuffle(cards.filter(card => previousKeys.has(card.dataset.photoKey)));
      const selected = shuffle([...fresh, ...repeated].slice(0, 6));
      if (selected.length > 1 && selected.map(card => card.dataset.photoKey).join('|') === previous.join('|')) selected.push(selected.shift());
      cards.forEach(card => { card.hidden = true; });
      selected.forEach(card => { card.hidden = false; grid.append(card); });
      grid.dataset.rotationReady = 'true';
      try { sessionStorage.setItem(storageKey, JSON.stringify(selected.map(card => card.dataset.photoKey))); } catch {}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rotate, { once: true });
  else rotate();
  document.addEventListener('shopify:section:load', rotate);
})();
  } catch(e) { console.error(e); }
})();

})();
